import type { ReactNode } from 'react';

interface BtnProps {
  kind?: string;
  icon?: string;
  children?: ReactNode;
  small?: boolean;
  onClick?: () => void;
}

export function Btn({ kind, icon, children, small, onClick }: BtnProps) {
  return (
    <button type="button" onClick={onClick}
      className={'mp-btn mp-btn--' + (kind || 'secondary') + (small ? ' mp-btn--sm' : '')}>
      {icon ? <i className={'bi ' + icon}></i> : null}
      {children}
    </button>
  );
}
